// extracted by mini-css-extract-plugin
export default {"label-select":"CSt2","labelSelect":"CSt2","label":"btgR"};